export const DATE_RANGES = {
  "2022": { start_time: "2022-06-01", end_time: "2022-06-31" },
  "2023": { start_time: "2023-06-01", end_time: "2023-06-31" },
};

export const MAX_STATIONS = 15;

export const YEARS = [2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026];

export const CURRENT_MAX = { month: 4, year: 2026 };
export const CURRENT_MIN = { month: 0, year: 2015 };

export const MONTHS = [
  {
    short: "Jan",
    value: "01",
  },
  {
    short: "Feb",
    value: "02",
  },
  {
    short: "Mar",
    value: "03",
  },
  {
    short: "Apr",
    value: "04",
  },
  {
    short: "May",
    value: "05",
  },
  {
    short: "Jun",
    value: "06",
  },
  {
    short: "Jul",
    value: "07",
  },
  {
    short: "Aug",
    value: "08",
  },
  {
    short: "Sep",
    value: "09",
  },
  {
    short: "Oct",
    value: "10",
  },
  {
    short: "Nov",
    value: "11",
  },
  {
    short: "Dec",
    value: "12",
  },
];

export const COLORS = {
  destination: "#D946EF",
  origin: "#f59e0b",
};
